export default __webpack_public_path__ + "static/get-in-touch-23ca6a56ff3ed01d17ebc69b332443c5.png";